var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0258 14.0913L18.595 17.6596L17.4158 18.8388L13.8475 15.2696C12.5197 16.334 10.8683 16.9129 9.16663 16.9104C5.02663 16.9104 1.66663 13.5504 1.66663 9.41045C1.66663 5.27045 5.02663 1.91045 9.16663 1.91045C13.3066 1.91045 16.6666 5.27045 16.6666 9.41045C16.669 11.1121 16.0901 12.7636 15.0258 14.0913ZM13.3541 13.4729C14.4117 12.3854 15.0023 10.9275 15 9.41045C15 6.18711 12.3891 3.57711 9.16663 3.57711C5.94329 3.57711 3.33329 6.18711 3.33329 9.41045C3.33329 12.6329 5.94329 15.2438 9.16663 15.2438C10.6837 15.2462 12.1415 14.6555 13.2291 13.5979L13.3541 13.4729Z",
    fill: "#9A99B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.243774)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/iconSearch.9949db11f1fac77eb85cf2f3c9b7d38c.svg";
export { ForwardRef as ReactComponent };